// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-code {
  background-color: rgb(var(--v-theme-code));
  color: rgb(var(--v-theme-on-code));
  border-radius: 4px;
  line-height: 1.8;
  font-size: 0.9em;
  font-weight: normal;
  padding: 0.2em 0.4em;
}
:where(.vuetify-styles) .v-code:has(> pre) {
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCode/VCode.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB","sourcesContent":[".v-code {\n  background-color: rgb(var(--v-theme-code));\n  color: rgb(var(--v-theme-on-code));\n  border-radius: 4px;\n  line-height: 1.8;\n  font-size: 0.9em;\n  font-weight: normal;\n  padding: 0.2em 0.4em;\n}\n.v-code:has(> pre) {\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
